module.exports = __webpack_public_path__ + "media/public/images/icon-filter-selected-1b77c08e199f47a502d42e8093a0bcd1.svg";